// Installs polyfills to support a subset of WebGL2 APIs on WebGL1 contexts

export {default as polyfillContext} from './polyfill-context';
export {default} from './polyfill-context';
